<script setup lang="ts">
import Customer from "@/customer/interfaces/Customer";
import {Check, TriangleAlert, X} from "@lucide/vue";
import {computed} from "vue";
import formatHelper from "@/core/helpers/formatHelper";

defineProps<{
    customer: Customer,
    channel: "sms" | "push",
}>();

const customerPhone = defineModel<string | null>("customerPhone", {required: true});

const isPhoneValid = computed(() => {
    return formatHelper.phoneIsValid(customerPhone.value ?? '');
});
</script>

<template>
  <div class="step-card">
    <div class="flex flex-col gap-6">
      <div class="flex">
        <div class="flex flex-col flex-1">
          <h3 class="items-center flex gap-2">
            {{ customer.information?.first_name }} {{ channel === 'sms' ? 'n\'a pas l\'application Apodis' : 'a l\'application Apodis' }}
            <X v-if="channel==='sms'" color="red" :size="20" />
            <Check v-else color="green" :size="20" />
          </h3>
          <p v-if="channel === 'sms'">
            Les rappels seront envoyés par SMS.
          </p>
          <p v-else>
            Les rappels seront envoyés par notifications directement sur l'application du patient
          </p>
        </div>
        <div class="w-20">
          <img src="@/assets/images/iphone-mockup.png" alt="iphone-mockup">
        </div>
      </div>
      <div v-if="channel === 'sms'" class="flex justify-between items-center gap-x-3 text-primary">
        <p>Numéro de {{ customer.information.first_name }}</p>
        <div class="flex items-end gap-2">
          <input
            v-model="customerPhone" size="18"
            type="tel"
            placeholder="Numéro de mobile"
            class="bg-gray-100 rounded"
          >
          <v-tooltip v-if="!isPhoneValid">
            <template #activator="{ props }">
              <div v-bind="props" class="flex items-center">
                <TriangleAlert v-if="!isPhoneValid" color="red" />
              </div>
            </template>
            <span>Veuillez renseigner un numéro de téléphone valide</span>
          </v-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
